import { useEffect, useEffectEvent, useState } from 'react';

export const PASSWORD_CHANGE_SUCCESS_TIMEOUT_MS = 10 * 1000;
const PASSWORD_CHANGE_TIME_INDICATOR_INTERVAL_MS = 1000;

export function useSuccessCountdown(isActive: boolean, onFinished: () => void | Promise<void>) {
  const [remainingMs, setRemainingMs] = useState(PASSWORD_CHANGE_SUCCESS_TIMEOUT_MS);
  const handleFinished = useEffectEvent(onFinished);

  useEffect(() => {
    if (!isActive) {
      return;
    }

    const startedAt = Date.now();
    const updateTimeIndicator = () => {
      setRemainingMs(Math.max(0, PASSWORD_CHANGE_SUCCESS_TIMEOUT_MS - (Date.now() - startedAt)));
    };

    const initialUpdateTimeoutId = window.setTimeout(updateTimeIndicator, 0);
    const intervalId = window.setInterval(updateTimeIndicator, PASSWORD_CHANGE_TIME_INDICATOR_INTERVAL_MS);
    const timeoutId = window.setTimeout(() => void handleFinished(), PASSWORD_CHANGE_SUCCESS_TIMEOUT_MS);

    return () => {
      window.clearTimeout(initialUpdateTimeoutId);
      window.clearInterval(intervalId);
      window.clearTimeout(timeoutId);
    };
  }, [isActive]);

  return isActive ? remainingMs : PASSWORD_CHANGE_SUCCESS_TIMEOUT_MS;
}
